const AUTH_TYPES = [
  "api_key",
  "bedrock_api_token",
  "bedrock_aws_credentials",
  "ollama"
];
const isProviderAuth = (value) => {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  return AUTH_TYPES.includes(value.type);
};
export const toProviderAuth = (value) => isProviderAuth(value) ? value : void 0;
export const emptyAuthFor = (provider, region) => {
  switch (provider) {
    case "bedrock":
      return { type: "bedrock_api_token", region };
    case "ollama":
      return { type: "ollama" };
    default:
      return { type: "api_key" };
  }
};
